import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TenderService } from '../../services/tender.service';
import { Subscription } from 'rxjs';
import { PrintNoticeDto } from '../../models/notices/notice.models';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { LoggedInUserService } from '../../auth/logged.in.user';

@Component({
    selector: 'tenders/print',
    template: require('./print.component.html')
})
export class PrintTenderComponent implements OnInit, OnDestroy, AfterViewInit {
    routeParamsSub: Subscription;
    tender: PrintNoticeDto;


    @BlockUI('print-area-block') blockUi: NgBlockUI;

    @ViewChild('hvtS1', { static: false }) hvtS1Comp: any;
    @ViewChild('hvtS2', { static: false }) hvtS2Comp: any;
    @ViewChild('hvtS3', { static: false }) hvtS3Comp: any;
    @ViewChild('hvtS4', { static: false }) hvtS4Comp: any;
    @ViewChild('hvtS6', { static: false }) hvtS6Comp: any;

    constructor(private readonly tenderService: TenderService,
        private readonly route: ActivatedRoute,
        private readonly loggedInUserService: LoggedInUserService) {

    }

    ngOnInit() {
        if (this.routeParamsSub) {
            this.routeParamsSub.unsubscribe();
        }

        this.blockUi.start();

        this.routeParamsSub = this.route.params.subscribe(params => {
            const tenderId = +params['id'];

            this.tenderService.getForPrint(tenderId).subscribe((result: PrintNoticeDto) => {
                this.tender = result;

                if (result.hvtSection1) {
                    this.hvtS1Comp.populate(result.hvtSection1);
                }

                if (result.hvtSection2) {
                    this.hvtS2Comp.populate(result.hvtSection2);
                }

                if (result.hvtSection3) {
                    this.hvtS3Comp.populate(result.hvtSection3);
                }

                if (result.hvtSection4) {
                    this.hvtS4Comp.populate(result.hvtSection4);
                }

                if (result.hvtSection6) {
                    this.hvtS6Comp.populate(result.hvtSection6);
                }

                this.blockUi.stop();
                //added a timer to stop print firing before the window's loaded

                window.setTimeout(() => {
                        window.print();
                    },
                    1000);
            });
        });
    }

    ngAfterViewInit() {
        jQuery('body').addClass('white-bg');
    }

    ngOnDestroy() {
        if (this.routeParamsSub) {
            this.routeParamsSub.unsubscribe();
        }
        jQuery('body').removeClass('white-bg');
    }

    splitMultiLine(obj: string, lineBreak: string = '<br/>') {
        if (obj) {
            return obj.split(lineBreak);
        }
        return [];
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tenders/print.component.ts